import {
  ConsumerPageLayout,
  DefaultSeo,
  NotFoundPage,
  ScrollToTopOnNavigation,
} from "@appcaire/shared/seo";
import { Route, Routes, useLocation } from "react-router-dom";
import { StockholmPageViewTracker } from "./components/StockholmPageViewTracker";
import { JourneyProvider } from "./contexts/JourneyContext";
import {
  STOCKHOLM_NAV_ITEMS,
  STOCKHOLM_NOT_FOUND_LINKS,
  STOCKHOLM_SEARCH_CONFIG,
} from "./lib/site";
import ComparePage from "./pages/ComparePage";
import { DistrictIndexPage, DistrictPage } from "./pages/DistrictPages";
import FinderPage from "./pages/FinderPage";
import GuidePage, { GuideIndexPage } from "./pages/GuidePage";
import HomePage from "./pages/HomePage";
import ProviderPage from "./pages/ProviderPage";
import StaticPage from "./pages/StaticPage";
import { ShortlistDock } from "./shortlist/ShortlistDock";
import { ShortlistProvider } from "./shortlist/ShortlistContext";

export default function App() {
  const location = useLocation();
  return (
    <>
      <DefaultSeo siteKey="stockholm" />
      <StockholmPageViewTracker />
      <ScrollToTopOnNavigation />
      <JourneyProvider>
        <ShortlistProvider>
          <ConsumerPageLayout
            brandName="Stockholms Hemtjänstguide"
            brandNameShort="Stockholm"
            homeLink="/"
            navItems={STOCKHOLM_NAV_ITEMS}
            siteKey="stockholm"
            searchConfig={STOCKHOLM_SEARCH_CONFIG}
            location={location}
          >
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/hitta-hemtjanst" element={<FinderPage />} />
              <Route path="/stadsdelar" element={<DistrictIndexPage />} />
              <Route path="/stadsdelar/:slug" element={<DistrictPage />} />
              <Route path="/utforare/:slug" element={<ProviderPage />} />
              <Route path="/jamfor" element={<ComparePage />} />
              <Route path="/guider" element={<GuideIndexPage />} />
              <Route path="/guider/:slug" element={<GuidePage />} />
              <Route path="/:page" element={<StaticPage />} />
              <Route
                path="*"
                element={
                  <NotFoundPage
                    showAttemptedPath={import.meta.env.DEV}
                    navigationLinks={STOCKHOLM_NOT_FOUND_LINKS}
                  />
                }
              />
            </Routes>
          </ConsumerPageLayout>
          <ShortlistDock />
        </ShortlistProvider>
      </JourneyProvider>
    </>
  );
}
